import { render, staticRenderFns } from "./TenantLogo.vue?vue&type=template&id=2a989844&scoped=true&"
import script from "./TenantLogo.vue?vue&type=script&lang=js&"
export * from "./TenantLogo.vue?vue&type=script&lang=js&"
import style0 from "./TenantLogo.vue?vue&type=style&index=0&id=2a989844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a989844",
  null
  
)

export default component.exports